import React from 'react';
import '../CSS/CurrentIssue.css';

const CurrentIssue = () => {
    return (
        <div className="current-issue-container">
            <div className="current-issue-content">
                <h1 className="page-title">Current Issue</h1>
                <div className="issue-details">
                    <h2>Innovative Trends in Multidisciplinary Engineering (ITME)</h2>
                    <p className="issue-info">Volume 2, Issue 1</p>
                </div>

                <div className="call-for-papers-section">
                    <h3>Artificial Intelligence and Digital Governance</h3>
                    <div className="issue-description">
                        <p>
                            Integrating Artificial Intelligence with Governance frameworks to build Transparent, secure, ethical, and inclusive digital ecosystems for future ready public administration and citizen centric services.
                        </p>

                        <h4>Topics of Interest (but not limited to)</h4>
                        <ul>
                            <li>Artificial Intelligence and Intelligent Decision Support Systems</li>
                            <li>Digital Governance, E-Governance, and Public Administration</li>
                            <li>AI Governance, Ethics, Trust, and Responsible Innovation</li>
                            <li>Cybersecurity, Privacy, Data Protection, and Digital Right</li>
                            <li>Computational Law, Legal Informatics, and Regulatory Technologies</li>
                            <li>Blockchain, Digital Identity, and Trustworthy Digital Ecosystems</li>
                            <li>Smart Cities, IoT, Cloud Computing, and Citizen-Centric Services</li>
                            <li>Emerging Technologies, Digital Transformation, and Future Governance Challenges</li>
                        </ul>

                        <h4>Publication Opportunity</h4>
                        <p><strong>No APC | Open Access</strong></p>

                        <h4>Submission Process</h4>
                        <p>
                            Scan the QR or email the PDF and plagiarism report (only Turnitin) to:{' '}
                            <a href="mailto:editor.itme@krmangalam.edu.in" className="email-link">editor.itme@krmangalam.edu.in</a>
                        </p>
                    </div>
                    <div className="call-for-papers-image-container">
                        <img 
                            src="/ITME_Call_for_Papers.jpeg" 
                            alt="ITME Call for Papers - July 2026 Issue" 
                            className="call-for-papers-image"
                            onError={(e) => {
                                e.currentTarget.style.display = 'none';
                                e.currentTarget.nextSibling.style.display = 'block';
                            }}
                        />
                        <div className="image-fallback" style={{ display: 'none' }}>
                            <p>Call for Papers image not available. Please contact the editorial office.</p>
                        </div>
                    </div>
                    
                    <div className="download-section">
                        <p>
                            <a 
                                href="/ITME_Call_for_Papers.pdf" 
                                className="download-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                📄 Download Call for Papers (PDF)
                            </a>
                        </p>
                    </div>
                </div>

                <div className="submission-info">
                    <h3>Important Dates</h3>
                    <ul>
                        <li><strong>Abstract Submission:</strong> 17 August, 2026</li>
                        <li><strong>Notification of Abstract Acceptance:</strong> 14 September, 2026</li>
                        <li><strong>Full Paper Submission:</strong> 18 October, 2026</li>
                        <li><strong>Notification of Paper Acceptance:</strong> 16 November, 2026</li>
                    </ul>
                </div>

                <div className="contact-section">
                    <h3>Submission</h3>
                    <p>
                        Submit your manuscript through our <a href="/form" className="submission-link">online submission system</a> or 
                        email directly to <a href="mailto:editor.itme@krmangalam.edu.in" className="email-link">editor.itme@krmangalam.edu.in</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CurrentIssue;
